import { Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { isEmpty } from "lodash";

const AnswerRadio = ({ answer, styles }) => {
  const answerDetails = answer?.answer?.other_details;

  return (
    <>
      {answerDetails?.radio_tag && (
        <View style={{ ...styles.flex, gap: "30px", marginTop: "3px" }}>
          <Text style={{ ...styles.para }}>{answerDetails?.radio_tag}</Text>
          {/* <Text style={{ ...styles.para }}>“location”</Text> */}
        </View>
      )}
      {Object.entries(answerDetails.dd_labels || {}).map(([key, value], index) => (
        <View key={index} style={{ ...styles.flex, gap: "5px", marginTop: "3px" }}>
          <Text style={{ ...styles.para }}>{key}:</Text>
          <Text style={{ ...styles.para }}>{value}</Text>
        </View>
      ))}
      
    </>
  );
};

export default AnswerRadio;
